var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{attrs:{"show":_vm.show},on:{"close":_vm.close}},[_c('login-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }